export const useDatabase = () => {
  const uds = useDatabaseStore()
  const {
    isDatabaseStoreLoaded,
    paymentSystems,
    eventTaxes,
    activities,
    personasSetups,
    personasGroups,
    eventOptions
  } = storeToRefs(uds)

  const event = useEventStore()

  const fetchAndMapData = async (url, transformer) => {
    const { data, promise } = useFetch(`/api/v1/${url}`, null, 'GET')
    await promise
    return transformer(data.value.data)
  }

  // Funciones individuales para cada fetch

  const getPaymentSystems = async () => {
    return fetchAndMapData(`events/${event.event.id}/payment-systems/${true}`, data =>
      data.map(element => ({
        id: element.id,
        value: element.id,
        text: element.name,
        label: element.name
      }))
    )
  }
  const fetchEventTaxes = async () => {
    return fetchAndMapData(`events/${event.event.id}/taxes/true`, data =>
      data.map(element => ({
        id: element.id,
        value: element.id,
        text: element.name,
        label: element.name
      }))
    )
  }

  const fetchActivities = async () => {
    return fetchAndMapData(`events/${event.event.id}/stock/activities/true`, data =>
      Object.values(data).map(element => ({
        value: element.id,
        label: element.name
      }))
    )
  }
  const fetchEventOptions = async () => {
    return fetchAndMapData(`events/${event.event.id}/eventoptions`, data => data)
  }

  const fetchPersonasSetups = () => {
    return fetchAndMapData(`personasetups/event/${event.event.id}/true?no_paginate=true`, data =>
      data.map(element => ({
        value: element.id,
        label: element.name
      }))
    )
  }

  const fetchPersonaGroups = () => {
    return fetchAndMapData(`events/${event.event.id}/persona-groups/true`, data =>
      data.map(element => ({
        value: element.id,
        label: element.name
      }))
    )
  }

  const initializeDatabase = async () => {
    try {
      const [
        activitiesData,
        personasSetupsData,
        personasGroupsData,
        paymentSystemsData,
        eventTaxesData,
        eventOptionsData
        // languagesData,
      ] = await Promise.all([
        fetchActivities(),
        fetchPersonasSetups(),
        fetchPersonaGroups(),
        getPaymentSystems(),
        fetchEventTaxes(),
        fetchEventOptions()
        // fetchLanguages(),
        // fetchEvents(),
      ])
      activities.value = activitiesData
      personasSetups.value = personasSetupsData
      personasGroups.value = personasGroupsData
      paymentSystems.value = paymentSystemsData
      eventTaxes.value = eventTaxesData
      eventOptions.value = eventOptionsData

      isDatabaseStoreLoaded.value = true
    } catch (error) {
      console.error('Error loading database:', error)
      // isDatabaseStoreLoaded.value = false
    }
  }

  return {
    initializeDatabase
  }
}
